import { Field, Form } from 'react-final-form';
import { FormFormattedField, FormInput, ModalWrapper } from '../../../../components';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { cutTextElipsis, normalizeFormattedField } from '../../../../utils';
import { useMemo, useState } from 'react';
import { ConfirmDropReserveModal } from './ConfirmDropReservePriceModal';
import { usePlaceAlternativeOfferMutation } from 'services/api/alternative-offers';
import { modalsHide, snackShow } from 'actions';
import { validateCounter } from 'utils/validators';

const StyledGrid = styled(Grid)`
  display: flex;
  align-items: center;

  & > * {
    flex: 1 1 100%;
  }
`;

const StyledLabel = styled(Typography)`
  color: #757575;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 16px;
`;

const StyledField = styled(Field)`
  background: #f5f5f5;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-top: 5px;
  border-radius: 4px;
  font-size: 16px;
  height: 60px;
  div {
    flex-grow: 1;
  }
`;

export const MakeAlternativeOfferModal = ({ currentVehicle }: any) => {
  const [dropReserveModalOpen, setDropReserveModalOpen] = useState(false);
  const dispatch = useDispatch();

  const modalName = `makeAlternativeOffer-${currentVehicle.id}`;

  const modalTitle = `Counter for ${cutTextElipsis(
    `${currentVehicle.year} ${currentVehicle.make} ${currentVehicle.model}`,
    20
  )}`;

  const [makeAlternativeOffer] = usePlaceAlternativeOfferMutation();

  const submitForm = async (values: any) => {
    const response = await makeAlternativeOffer({ vehicle_id: currentVehicle.id, amount: Number(values.amount) });
    if ('error' in response) {
      dispatch(snackShow({ type: 'error', message: 'Failed to counter' }));
    } else {
      dispatch(snackShow({ message: 'Successful counter' }));
    }

    dispatch(modalsHide(modalName));
  };

  const initialValues = useMemo(
    () => ({
      amount: currentVehicle.active_alternative_offer?.amount || null,
      reserve_price: currentVehicle.reserve_price
    }),
    [currentVehicle.active_alternative_offer]
  );

  const validate = (value: number) => {
    if (!value || !currentVehicle.active_alternative_offer) return;
    if (Number(value) <= currentVehicle.active_alternative_offer.amount) {
      return `Counter should be higher then previous`;
    }
  };

  return (
    <Form onSubmit={submitForm} initialValues={initialValues} keepDirtyOnReinitialize>
      {({ handleSubmit, submitting, values, form }) => {
        return (
          <form id={modalName} onSubmit={handleSubmit}>
            <ModalWrapper
              // @ts-ignore
              title={modalTitle}
              submitting={submitting}
              handleSubmit={form.submit}
              modalId={modalName}
              // cancelAdditionalAction={reset}
              className="edit-vehicle-bid-modal"
              actionsClassName="edit-vehicle-bid-modal-actions"
              submitText={'Counter'}
              cancelText={'Cancel'}
            >
              <Grid container>
                <StyledGrid item xs={12}>
                  <StyledField
                    name="amount"
                    component={FormFormattedField}
                    placeholder=""
                    // @ts-ignore
                    thousandSeparator
                    allowNegative={false}
                    fixedDecimalScale
                    prefix="$"
                    customInput={FormInput}
                    disableUnderline
                    parse={normalizeFormattedField}
                    validate={validateCounter}
                  />
                </StyledGrid>
              </Grid>
            </ModalWrapper>
          </form>
        );
      }}
    </Form>
  );
};
